export default __webpack_public_path__ + "static/media/screen_facebook_7_1.1d52d6c6.png";